import { DateTime } from 'luxon'

import { IIdentifiable } from '@/common/models/models'

interface IChatMessage extends IIdentifiable {
    author: string
    content: string
    ip: string | null
    created_at: string
}

class ChatMessage implements IChatMessage {
    id = 0
    author = ''
    content = ''
    ip: string | null = null
    created_at = ''

    constructor (dto?: IChatMessage) {
        if (dto) {
            this.id = dto.id
            this.author = dto.author
            this.content = dto.content
            this.ip = dto.ip
            this.created_at = dto.created_at
        }
    }

    public static create (author: string, content: string): ChatMessage {
        const message = new ChatMessage()
        message.author = author
        message.content = content

        return message
    }

    get humanReadableCreatedAt (): string {
        return DateTime.fromISO(this.created_at).toFormat('d/MM/yyyy HH:mm:ss')
    }
}

export {
    IChatMessage, ChatMessage
}
